export function useDynamicStrings() {
  const dynamicStrings = useState<Record<string, string>>(
    'dynamicStrings',
    () => ({}),
  )

  const setDynamicStrings = (strings: Record<string, string>) => {
    dynamicStrings.value = {
      ...dynamicStrings.value,
      ...strings,
    }
  }

  return {
    dynamicStrings: dynamicStrings.value,
    setDynamicStrings,
  }
}
